export default __webpack_public_path__ + "static/media/crest_trans_brown.01955e04.png";